import { render, staticRenderFns } from "./NewReleaseDialog.vue?vue&type=template&id=572c6185&scoped=true"
import script from "./NewReleaseDialog.vue?vue&type=script&lang=js"
export * from "./NewReleaseDialog.vue?vue&type=script&lang=js"
import style0 from "./NewReleaseDialog.vue?vue&type=style&index=0&id=572c6185&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572c6185",
  null
  
)

export default component.exports